import { render, staticRenderFns } from "./ByInsured.vue?vue&type=template&id=0b25b0c1&"
import script from "./ByInsured.vue?vue&type=script&lang=js&"
export * from "./ByInsured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports